import React, { Component } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import TitleBar from "../_common/TitleBar";
import adrListTitleBarMenu from "../_titleBarMenus/adrListTitleBarMenu";
import _ from "lodash";
import Table from "../_common/Table";
import adrActions from "../../_actions/adrActions";
import moment from "moment";
// import BlockUi from "react-block-ui";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledButtonDropdown,
} from "reactstrap";
// import AdrListSearchBar from "./adrListSearchBar";
// import "react-block-ui/style.css";
import "loaders.css/loaders.min.css";
import "./adrList.css";
import { actionScripts } from "../../_helpers/actionScripts";
import FilterGroup from "../_common/FilterGroup";
import { getPermissions } from "../../_helpers/authorize";
import { DOCTYPE } from "../../_constants/docTypeConstants";
import { projSelectorConstants } from "../../_constants/projSelectorConstants";
import { docPermConstants } from "../../_constants/permissionConstants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AdrPreview from "./AdrPreview";
import AlertModal from "../_common/AlertModal";
import cem4601PdfActions from "../../_actions/cem4601PdfActions";
import projActions from "../../_actions/projActions";
import { stringifyJSON } from "../../_utils/generalUtils";

class AdrList extends Component {
  state = {
    selectedIncludeFrom: null, // initialized in cdm
    includeFromOptions: [], // initialized in cdm
    includeFromDate: [], // initialized in cdm; corresponding list of dates to 'includeFromOptions'
    sortColumn: { path: "reportStartDate", order: "desc" },
    dateFilter: null,
    authorFilter: "",
    selectedStatusFilters: [],
    selectedOnlyFilter: false,
    disableAllSort: false,
    selectedAdr: null, // set from handleClick_tr
    selectedAdrs: {},
    selectedAll: false, // toggler to determine whether to clear selections
    selectedAdrPreviewData: null,
    permissions: null, // initialized in cdm
    showAlert_deleteConfirm: false,
  };

  columns = [
    {
      path: "select",
      label: <FontAwesomeIcon icon="check-square" className="fa-fw" />,
      thClassName: "adrlist-th-select table-tr-md-edge",
      tdClassName: "table-tr-md-edge align-middle",
      content: (adr) => this.renderAdrSelect(adr),
      customHeaderClick: () => this.toggleSelectAll(),
      disableSort: true,
    },
    {
      path: "reportStartDate",
      label: "Date",
      thClassName: "adrlist-th-date table-tr-md",
      tdClassName: "adrlist-th-date table-tr-md align-middle",
      content: (adr) => (
        <span className={`${adr.isSuperseded ? "text-muted font-italic" : ""}`}>
          {`${moment(adr.reportStartDate).format("MM/DD/YYYY")}`}
        </span>
      ),
    },
    {
      path: "reportNo",
      label: "Rpt",
      thClassName: "adrlist-th-rptno table-tr-md",
      tdClassName: "adrlist-th-rptno table-tr-md align-middle",
      content: (adr) => (
        <span className={`${adr.isSuperseded ? "text-muted font-italic" : ""}`}>
          {adr.reportNo}
        </span>
      ),
    },
    {
      path: "authorFullName",
      label: "Author",
      thClassName: "adrlist-th-author table-tr-md",
      tdClassName: "adrlist-th-author table-tr-md align-middle",
      content: (adr) => (
        <span className={`${adr.isSuperseded ? "text-muted font-italic" : ""}`}>
          {adr.authorFullName}
        </span>
      ),
    },
    {
      path: "status",
      label: "Status",
      thClassName: "adrlist-th-status table-tr-md",
      tdClassName: "adrlist-th-status table-tr-md align-middle",
      content: (adr) => this.renderAdrStatus(adr),
    },
    // {
    //   path: "statusDate",
    //   label: "Status Date",
    //   thClassName: "adrlist-th-statusDate table-tr-md",
    //   thColSpan: "2",
    //   tdClassName: "adrlist-td-statusDate table-tr-md align-middle",
    //   content: (adr) => moment(adr.statusDate).format("L"),
    // },
    {
      path: "snippets",
      label: "",
      thClassName: "adrlist-th-statusDate table-tr-md",
      tdClassName: "adrlist-th-statusDate table-tr-md align-middle",
      disableSort: true,
      content: (adr) => this.renderSnippet(adr),
    },
    {
      path: "openAdr",
      label: "",
      thClassName: "adrlist-th-openAdr table-tr-md",
      tdClassName: "adrlist-th-openAdr table-tr-md-edge text-right align-middle",
      content: (adr) => this.renderPreviewLink(adr),
      disableSort: true,
    },
  ];

  componentDidMount() {
    const { dispatch, tab, user, isSearchResult } = this.props;

    // Build includeFrom filter options
    let includeFromOptions = [];
    let includeFromDate = [];
    for (let i = 1; i < 7; i++) {
      const includeFrom = moment().subtract(i, "months").startOf("month");
      includeFromOptions.push({
        value: i - 1,
        label: includeFrom.format("MM/DD/YYYY"),
      });
      includeFromDate.push(includeFrom.format());
    }
    includeFromOptions.push({
      value: 6,
      label: "All",
    });
    includeFromDate.push(moment("01-01-2010", "MM-DD-YYYY").format());

    if (!isSearchResult) {
      dispatch(
        adrActions.fetchAll(tab.projectId, tab.tabId, includeFromOptions[0].includeFrom)
      ).then(() => {
        // // Pre-set filters based on project role
        // let selectedStatusFilters = [];
        // if (projectRoleClass === "ARESR")
        //   selectedStatusFilters = [
        //     "filterRejected",
        //     "filterDraft",
        //     "filterSubmitted"
        //   ];
        // if (projectRoleClass === "RESR")
        //   selectedStatusFilters = [
        //     "filterSubmitted",
        //     "filterRejected",
        //     "filterApproved"
        //   ];
        // this.setState({ selectedStatusFilters });
      });
    }

    const projectRole = user.projectRoles.find(role => role.projectId === tab.projectId);

    this.setState({
      selectedIncludeFrom: includeFromOptions[0],
      includeFromOptions,
      includeFromDate,
      permissions: getPermissions({
        user,
        docType: DOCTYPE.ADR,
        projectId: tab.projectId,
        creatorId: null,
      }),
    });
  }

  handleSort = (sortColumn) => this.setState({ sortColumn });

  toggleSelectAll = () => {
    const { selectedAll } = this.state;
    if (!selectedAll) {
      const data = this.getData();
      let selectedAdrs = {};
      data.forEach((adr) => (selectedAdrs[adr.assistantDailyReportId] = true));
      this.setState({ selectedAdrs, selectedAll: true });
    } else this.setState({ selectedAdrs: {}, selectedAll: false });
  };

  deselectFilteredOutItems = () => {
    const adrIds = this.getData().map((adr) => adr.assistantDailyReportId);
    const selectedAdrs = { ...this.state.selectedAdrs };
    const adrIdsToDeselect = Object.keys(selectedAdrs).filter(
      (adrId) => !adrIds.includes(+adrId)
    );
    adrIdsToDeselect.forEach((adrId) => (selectedAdrs[adrId] = false));
    this.setState({ selectedAdrs });
  };

  handleChange_includeFrom = (selectedIncludeFrom) => {
    const { tab, dispatch } = this.props;
    const { includeFromDate } = this.state;
    dispatch(
      adrActions.fetchAll(
        tab.projectId,
        tab.tabId,
        includeFromDate[selectedIncludeFrom.value]
      )
    ).then(() => this.deselectFilteredOutItems());
    this.setState({ selectedIncludeFrom });
  };

  handleChange_dateFilter = (dateFilter) =>
    this.setState({ dateFilter }, this.deselectFilteredOutItems);

  handleChange_authorFilter = (e) =>
    this.setState({ authorFilter: e.target.value }, this.deselectFilteredOutItems);

  handleChange_statusFilter = (selectedStatusFilters) =>
    this.setState(
      {
        selectedStatusFilters,
        disableAllSort: selectedStatusFilters.length > 0,
      },
      this.deselectFilteredOutItems
    );

  handleClick_selectedOnlyFilter = (e) => {
    e.preventDefault();
    this.setState(
      { selectedOnlyFilter: !this.state.selectedOnlyFilter },
      this.deselectFilteredOutItems
    );
  };

  handleClick_clearFilters = (e) => {
    e.preventDefault();
    this.setState({ dateFilter: null, authorFilter: "" });
  };

  handleClick_createNewAdr = (e) => {
    const { tab, user } = this.props;
    e.preventDefault();
    actionScripts.CREATE_ADR_V2.run(user.userId, tab.projectId);
  };

  handleChange_check = (adrId) => (e) => {
    e.stopPropagation();
    const selectedAdrs = { ...this.state.selectedAdrs };
    selectedAdrs[adrId] = e.target.checked;
    // Individual selections should disable selectedAll toggler
    this.setState({ selectedAdrs, selectedAll: false });
  };

  handleTitleBarAction = (action) => () => {
    const { dispatch, tab } = this.props;
    if (action === "refreshAdrList") {
      dispatch(adrActions.fetchAll(tab.projectId, tab.tabId));
      this.setState({ selectedIncludeFrom: this.state.includeFromOptions[0] });
    }
  };

  handleAlert_deleteConfirm = (alertAction) => (e) => {
    e.preventDefault();
    if (alertAction === "accept") {
      const { selectedAdrs } = this.state;
      const { tab, adrList, user } = this.props;
      const selectedAdrIds = Object.entries(selectedAdrs)
        .filter((kvp) => kvp[1])
        .map((kvp) => +kvp[0]);
      selectedAdrIds.forEach((adrId) => {
        const adr = adrList.find((a) => a.assistantDailyReportId === adrId);
        if (adr && adr.authorUserId === user.userId)
          actionScripts.DELETE_ADR.run(tab.projectId, adrId, null);
      });

      // Clear selections
      this.setState({ selectedAdrs: {} });
    }
    this.toggleAlert_deleteConfirm();
  };

  toggleAlert_deleteConfirm = () => {
    this.setState({ showAlert_deleteConfirm: !this.state.showAlert_deleteConfirm });
  };

  getData = () => {
    const { adrList, user } = this.props;
    const {
      sortColumn,
      dateFilter,
      authorFilter,
      selectedStatusFilters,
      selectedOnlyFilter,
      selectedAdrs,
      projectRoleClass,
    } = this.state;

    // Hide others' drafts and deleted
    const draftHidden = adrList
      ? adrList.filter(
          (adr) => !(adr.isDraft && adr.authorUserId !== user.userId) || adr.isDeleted
        )
      : [];

    const filteredByDate = dateFilter
      ? draftHidden.filter((i) => moment(i.reportStartDate).isSame(dateFilter, "day"))
      : draftHidden;
    const filteredByAuthor =
      authorFilter !== ""
        ? filteredByDate.filter((i) =>
            i.authorFullName.toLowerCase().includes(authorFilter.trim().toLowerCase())
          )
        : filteredByDate;
    let filteredByStatus =
      selectedStatusFilters.length > 0
        ? filteredByAuthor.filter(
            (adr) =>
              (selectedStatusFilters.includes("Draft") && adr.isDraft) ||
              (selectedStatusFilters.includes("Submitted") && adr.isSubmitted) ||
              (selectedStatusFilters.includes("Rejected") && adr.isRejected) ||
              (selectedStatusFilters.includes("Accepted") && adr.isApproved)
          )
        : filteredByAuthor;

    let sorted = [];

    // If status filters are selected, then enforce sorting by status orders
    // as defined in the Specifications.
    // Otherwise, allow user to custom sort by clicking table headers.
    if (filteredByStatus !== undefined && selectedStatusFilters.length > 0) {
      switch (projectRoleClass) {
        case "ARESR": {
          // Define the sort order of status - i.e. for ARESR, 'Rejected' will
          // always be at the top, sorted reverse chronologically.
          const statusOrder = ["Rejected", "Draft", "Submitted"];
          // The matching index of the statusOrder array defines sorting order.
          // Save the sorting order as a new property in filteredByStatus,
          // which is a temporary store of the adrList data.
          // There are 4 total statuses, so with 0-base index, 3 is maximum -
          // basically, if no matching status is found, show it last.
          filteredByStatus.forEach((adr) =>
            statusOrder.includes(adr.status)
              ? (adr.statusSortOrder = statusOrder.findIndex((so) => so === adr.status))
              : 3
          );
          sorted = _.orderBy(
            filteredByStatus,
            ["statusSortOrder", "reportStartDate"],
            ["asc", "desc"]
          );
          break;
        }
        case "RESR": {
          // See above case for documentation.
          const statusOrder = ["Submitted", "Rejected", "Accepted"];
          filteredByStatus.forEach((adr) =>
            statusOrder.includes(adr.status)
              ? (adr.statusSortOrder = statusOrder.findIndex((so) => so === adr.status))
              : 3
          );
          sorted = _.orderBy(
            filteredByStatus,
            ["statusSortOrder", "reportStartDate"],
            ["asc", "desc"]
          );
          break;
        }
        default: {
          sorted = _.orderBy(filteredByStatus, [sortColumn.path], [sortColumn.order]);
        }
      }
    } else sorted = _.orderBy(filteredByStatus, [sortColumn.path], [sortColumn.order]);

    // Finally, apply filtering by selected
    if (selectedOnlyFilter)
      sorted = sorted.filter(
        (adr) =>
          adr.assistantDailyReportId in selectedAdrs &&
          selectedAdrs[adr.assistantDailyReportId]
      );

    return sorted;
  };

  loadPreviewData = (selectedAdr) => {
    const { dispatch } = this.props;
    dispatch(adrActions.fetchPreviewData(selectedAdr.assistantDailyReportId)).then(
      (data) => this.setState({ selectedAdrPreviewData: data })
    );
  };

  handleClick_preview = (selectedAdr) => (e) => {
    e.preventDefault();
    e.stopPropagation();

    this.loadPreviewData(selectedAdr);
    this.setState({ selectedAdr });
  };

  handleClick_tr = (selectedAdr) => {
    const { tab } = this.props;
    actionScripts.FETCH_ADR.run(tab.projectId, selectedAdr.assistantDailyReportId);
    this.loadPreviewData(selectedAdr);
    this.setState({ selectedAdr });
  };

  handleClick_batchOpen = (e) => {
    e.preventDefault();
    const { selectedAdrs } = this.state;
    const { tab } = this.props;
    const selectedAdrIds = Object.entries(selectedAdrs)
      .filter((kvp) => kvp[1])
      .map((kvp) => +kvp[0]);
    selectedAdrIds.forEach((adrId) => actionScripts.FETCH_ADR.run(tab.projectId, adrId));
  };

  handleClick_batchDelete = (e) => {
    e.preventDefault();
    this.toggleAlert_deleteConfirm();
  };

  handleClick_batchPdf = (e) => {
    e.preventDefault();
    const { selectedAdrs } = this.state;
    const { dispatch, tab } = this.props;
    const selectedAdrIds = Object.entries(selectedAdrs)
      .filter((kvp) => kvp[1])
      .map((kvp) => +kvp[0]);
    dispatch(cem4601PdfActions.requestPdfs(selectedAdrIds));
  };

  renderAdrSelect = (adr) => {
    return (
      <div className="custom-control custom-checkbox pl-1">
        <input
          type="checkbox"
          name="adrSelect"
          className="align-middle"
          id={`adrSelect_${adr.assistantDailyReportId}`}
          style={{ width: "1.5rem", height: "1.5rem" }}
          value={this.state.selectedAdrs[adr.assistantDailyReportId] || false}
          checked={this.state.selectedAdrs[adr.assistantDailyReportId] || false}
          onClick={this.handleChange_check(adr.assistantDailyReportId)}
          onTouchEnd={this.handleChange_check(adr.assistantDailyReportId)}
          onChange={this.handleChange_check(adr.assistantDailyReportId)}
        />
      </div>
    );
  };

  renderBatchOptions = () => {
    const { selectedAdrs } = this.state;
    const selectedAdrIds = Object.entries(selectedAdrs)
      .filter((kvp) => kvp[1])
      .map((kvp) => +kvp[0]);
    if (selectedAdrIds.length > 0)
      return (
        <div className="mx-2 align-middle">
          <UncontrolledButtonDropdown className="mr-2" color="secondary">
            <DropdownToggle caret outline>
              Batch Actions{" "}
            </DropdownToggle>
            <DropdownMenu right>
              <DropdownItem id="adrBatchOpen" onClick={this.handleClick_batchOpen}>
                Open (All Selected)
              </DropdownItem>
              <DropdownItem id="adrBatchDelete" onClick={this.handleClick_batchDelete}>
                Delete (All Selected)
              </DropdownItem>
              <DropdownItem id="adrBatchPdf" onClick={this.handleClick_batchPdf}>
                Generate PDFs (All Selected)
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledButtonDropdown>
          {selectedAdrIds.length} Daily Reports selected.
        </div>
      );
  };

  renderPreviewLink = (adr) => {
    return (
      <button
        type="button"
        name={`adrOpenLink_${adr.assistantDailyReportId}`}
        id={`adrOpenLink_${adr.assistantDailyReportId}`}
        className="btn btn-outline-secondary btn-sm px-2 align-middle adrlist-preview-btn"
        onClick={this.handleClick_preview(adr)}
        onTouchEnd={this.handleClick_preview(adr)}
      >
        Info
      </button>
    );
  };

  renderPreview = () => {
    const { selectedAdr, selectedAdrPreviewData } = this.state;
    return (
      <AdrPreview
        adr={selectedAdr}
        previewData={selectedAdrPreviewData}
        renderAdrStatus={this.renderAdrStatus}
      />
    );
  };

  renderAdrStatus = (adr) => {
    let statusClass = "";
    let status = "";
    if (adr.isDraft) {
      status = "Draft";
      statusClass = "dark";
    }
    else if (adr.isSubmitted) {
      status = "Submitted";
      statusClass = "primary";
    }
    else if (adr.isSuperseded) {
      status = "Amended";
      statusClass = "secondary";
    } 
    else if (adr.isApproved) {
      status = "Accepted";
      statusClass = "success";
    }
    else if (adr.isRejected && !adr.isSubmitted) {
      status = "Rejected";
      statusClass = "danger";
    }
    statusClass = "span-bubble p-1 bg-" + statusClass;
    return <span className={statusClass}>{status}</span>;
  };

  renderSnippet = (adr) => {
    const superseded = (
      <span className="text-muted text-small w-100">
        <em>Superseded - see amendment</em>
      </span>
    );
    const amend = (
      <span
        className="badge p-1 mr-1"
        style={{ color: "black", border: "0.05rem solid black" }}
      >
        {`Amendment #${adr.amendmentNo}`}
      </span>
    );
    const att = (
      <span
        className="badge p-1 mr-1"
        style={{ color: "black", border: "0.05rem solid black" }}
      >
        <FontAwesomeIcon icon="paperclip" className="fa-fw" />
      </span>
    );
    const ta = (
      <span
        className="badge p-1 mr-1"
        style={{ color: "black", border: "0.05rem solid black" }}
      >
        TA
      </span>
    );
    return (
      <>
        {adr.isSuperseded && superseded}
        {adr.isAmendment && amend}
        {adr.hasAttachments && att}
        {adr.hasTentativeAgreements && ta}
      </>
    );
  };

  render() {
    const {
      sortColumn,
      selectedIncludeFrom,
      includeFromOptions,
      selectedOnlyFilter,
      permissions,
      disableAllSort,
      selectedAdr,
      showAlert_deleteConfirm,
    } = this.state;
    const { tab, user, toggleAdrSearchModal, isSearchResult, fetching } = this.props;
    const data = this.getData();
    return (
      <React.Fragment>
        <TitleBar
          titleText={
            isSearchResult ? "Daily Report Search Result" : "List of Daily Reports"
          }
          menu={adrListTitleBarMenu}
          disabledActions={{
            refreshAdrList: isSearchResult,
          }}
          handleTitleBarAction={this.handleTitleBarAction}
        />
        <div className="card mx-2 mt-3">
          <div className="card-body p-2">
            <div className="d-flex flex-row pb-2">
              <div className="form-inline form-row flex-grow-1">
                <label htmlFor="includeFrom" className="col-form-label">
                  <b>Show Reports Since:</b>
                </label>
                <Select
                  name="includeFrom"
                  id="includeFrom"
                  className="col-sm-2 mr-2"
                  value={selectedIncludeFrom}
                  options={includeFromOptions}
                  onChange={this.handleChange_includeFrom}
                  isSearchable={false}
                  isDisabled={isSearchResult}
                />
                <button
                  type="button"
                  name="advSearch"
                  id="advSearch"
                  className="btn btn-info"
                  onClick={toggleAdrSearchModal(tab.projectId, {
                    type: projSelectorConstants.USER_ASSIGNED,
                    lookupId: user.userId,
                  })}
                >
                  {isSearchResult ? "Modify Search..." : "Adv Search..."}
                </button>
                <span className="text-muted mx-1">|</span>
                <button
                  type="button"
                  name="createNewAdr"
                  id="createNewAdr"
                  className="btn btn-secondary"
                  onClick={this.handleClick_createNewAdr}
                  disabled={permissions && !permissions.includes(docPermConstants.CREATE)}
                >
                  <FontAwesomeIcon icon="file" className="fa-fw mr-2" />
                  New...
                </button>
              </div>
            </div>
            <div className="d-flex flex-row flex-wrap pb-2">
              <div className="mr-2">
                <FilterGroup
                  filters={["Draft", "Submitted", "Rejected", "Accepted"]}
                  onChange={this.handleChange_statusFilter}
                />
              </div>
              <div className="mr-2">
                <button
                  type="button"
                  name="filterSelected"
                  id="filterSelected"
                  className={`btn ${
                    selectedOnlyFilter ? "btn-success" : "btn-outline-success"
                  }`}
                  onClick={this.handleClick_selectedOnlyFilter}
                >
                  <FontAwesomeIcon icon="check-square" className="fa-fw" />
                </button>
              </div>
              {this.renderBatchOptions()}
            </div>
            <div className="row m-0">
              <div className="col-lg-8 col-sm-12 pr-1 pl-0">
                <div className="adrlist-table-container border">
                  {/* <BlockUi blocking={fetching}> */}
                  <Table
                    className="table table-hover adrlist-table w-100"
                    data={data}
                    idPropName="assistantDailyReportId"
                    columns={this.columns}
                    sortColumn={sortColumn}
                    onSort={this.handleSort}
                    handleClick_tr={this.handleClick_tr}
                    selectedItemId={selectedAdr && selectedAdr.assistantDailyReportId}
                    disableAllSort={disableAllSort}
                  />
                  {/* </BlockUi> */}
                </div>
              </div>
              <div className="col-lg-4 px-1 adrlist-preview">{this.renderPreview()}</div>
            </div>
          </div>
        </div>
        {showAlert_deleteConfirm && (
          <AlertModal
            alertTitle="Delete"
            alertTitleClass="bg-warning"
            alertTitleIcon="exclamation-triangle"
            alertText={
              `Are you sure you wish to delete selected Daily Reports?\n` +
              "(Note: you can only delete your own Daily Reports. Any that is not your own will be skipped over."
            }
            acceptCaption={"Yes"}
            acceptClass={"danger"}
            provideReject={true}
            rejectCaption={"No"}
            rejectClass={"secondary"}
            handleAlertAction={this.handleAlert_deleteConfirm}
            toggleAlertModal={this.toggleAlert_deleteConfirm}
            showAlertModal={showAlert_deleteConfirm}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    adrList: state.adr.openAdrLists[ownProps.tab.tabId]
      ? state.adr.openAdrLists[ownProps.tab.tabId].adrList
      : [],
    user: state.authentication.user,
    openTabs: state.mainTabs.openTabs,
    fetching: state.adr.fetching,
  };
};

export default connect(mapStateToProps)(AdrList);
